// extracted by mini-css-extract-plugin
module.exports = {"cherryInfoWrapper":"ClientCherryInfo_cherryInfoWrapper__2ebuw","title":"ClientCherryInfo_title__3yyFR","itemText":"ClientCherryInfo_itemText__3f2Qq"};